import LinkProvider from './hooks/useLink';

import { LinkProps } from './@types/LinkProps';
import LinkContainer from './handles/LinkContainer';

const Link = (props: LinkProps) => (
	<LinkProvider {...props}>
		<LinkContainer />
	</LinkProvider>
);

export default Link;
